import { render, staticRenderFns } from "./gtm.vue?vue&type=template&id=18ba760a&"
import script from "./gtm.vue?vue&type=script&lang=js&"
export * from "./gtm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports